module.exports = __webpack_public_path__ + "img/Luna.bc69f906.png";